<template>
  <b-dropdown :size="size || 'md'" right text="Table Options" @hide="saveChanges" ref="dropdown" :disabled="disabled">
    <b-dropdown-form style="min-width:320px" v-on:submit.prevent.stop="saveAndClose">
      <b-form-group label="Results per page:">
        <b-input-group>
          <b-form-select v-model="pageSize">
            <option :value="10">10</option>
            <option :value="25">25</option>
            <option :value="50">50</option>
          </b-form-select>
        </b-input-group>
      </b-form-group>
      <b-alert :show="!isValid" variant="danger">{{errorMessage}}</b-alert>
      <p class="text-right mb-0">
        <b-button size="sm" variant="secondary" @click="resetAndClose">Cancel</b-button>
        <b-button size="sm" variant="primary" @click="saveAndClose">Update</b-button>
      </p>
    </b-dropdown-form>
  </b-dropdown>
</template>

<script>

export default {
  name: 'TableOptions',
  props: ['settings', 'disabled', 'size'],
  components: {},
  data () {
    return {
      // sortColumn: this.settings.order[0].column,
      // sortOrder: this.settings.order[0].direction,
      pageSize: parseInt(this.settings.page_size || 25),
      isValid: true,
      errorMessage: ''
    }
  },
  computed: {},
  watch: {
    settings () {
      this.pageSize = parseInt(this.settings.page_size || 25)
    }
  },
  mounted () {
  },
  methods: {
    validate () {
      this.isValid = true
      return this.isValid
    },
    resetAndClose (evt) {
      this.pageSize = parseInt(this.settings.page_size || 25)
      this.isValid = true
      this.errorMessage = ''
      this.$refs.dropdown.hide()
    },
    saveChanges (evt) {
      if (this.validate()) {
        this.commit()
      } else {
        evt.preventDefault()
      }
    },
    saveAndClose () {
      if (this.validate()) {
        this.$refs.dropdown.hide()
      }
    },
    commit () {
      this.settings.page_size = this.pageSize
      this.$emit('input', this.settings)
    }
  }
}
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/reports/TableOptions.vue